import type { CopyShape } from "@tami/core/intl";

import type { CREATORS_SCRIPT_COPY_PT_BR } from "../creators-script.copy";

export const CREATORS_SCRIPT_COPY_ES_ES: CopyShape<typeof CREATORS_SCRIPT_COPY_PT_BR> = {
  creatorsIntro: {
    narrative: "La cartera de la Collab: a quién gestionas, con cuánto alcance y con qué acceso.",
  },
  creatorsSummary: {
    narrative: "Alcance sumado y engagement global de toda la cartera, más las plazas que ya has usado.",
    callout: "El tamaño de tu Collab en un solo número — y cuántas plazas te quedan.",
  },
  creatorsOverview: {
    narrative: "El creator entra por invitación y conecta sus propias redes. Sin hojas de cálculo de por medio.",
  },
  creatorsGrid: {
    narrative: "Una tarjeta por creator: foto, redes conectadas, seguidores, engagement y el acceso que te ha dado.",
    callout: "Tu propia Collab también está en la cartera — tiene redes y contenido.",
  },
  creatorsInvite: {
    narrative: "La invitación pendiente se queda a la vista hasta que el creator acepta — no te quedas esperando a ciegas.",
    callout: "¿Has invitado y todavía no ha aceptado? La tarjeta sigue ahí, marcada.",
  },
};
